import { render, staticRenderFns } from "./CbsFormDesignerPreview.vue?vue&type=template&id=4b8681e6&scoped=true"
import script from "./CbsFormDesignerPreview.vue?vue&type=script&lang=js"
export * from "./CbsFormDesignerPreview.vue?vue&type=script&lang=js"
import style0 from "./CbsFormDesignerPreview.vue?vue&type=style&index=0&id=4b8681e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8681e6",
  null
  
)

export default component.exports